var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IframeWrap',{attrs:{"option":_vm.wrapSize},on:{"loaded":_vm.handleLoad}},[_c('iframe',{staticClass:"min-w-full",staticStyle:{"height":"100%"},attrs:{"allowfullscreen":"true","src":_vm.fullSrc,"allow":"clipboard-read"}})])}
var staticRenderFns = []

export { render, staticRenderFns }